import gql from 'graphql-tag';

const DEVICE_TYPE = gql`
  query Query {
    deviceTypeList {
      identifier
      version
      name
      selectiveSensors
      subTypes {
        name
        type
        sensors
      }
      sensors
    }
  }
`;

export default DEVICE_TYPE;
